import { ConfirmModalComponent } from "./confirm.modal";
import { TemplateModalComponent } from "./template.modal";

export const MODALS = [
    ConfirmModalComponent,
    TemplateModalComponent,
];
